import React from "react";
import { Inbox } from "lucide-react";

/**
 * The app's one "there is nothing here" surface.
 *
 * Before this existed the desktop sheet said "No data available" in a hardcoded
 * `text-gray-500`, the mobile card list said the same thing through
 * `.msheet-empty`, and half a dozen panels each invented their own padding — so
 * the same state looked different depending on which viewport you were on.
 *
 * Props:
 *   icon     lucide component reference (defaults to Inbox)
 *   title    the headline; keep it short and specific ("No customers yet")
 *   hint     optional second line explaining what to do about it
 *   action   optional node, usually a button
 *   compact  tighter padding, for use inside a modal or a small panel
 */
export default function EmptyState({ icon: Icon = Inbox, title = "No data available", hint, action, compact = false }) {
  return (
    <div className={`empty-state${compact ? " is-compact" : ""}`}>
      <Icon className="empty-state-icon" size={compact ? 22 : 28} aria-hidden="true" />
      <p className="empty-state-title">{title}</p>
      {hint && <p className="hint-t empty-state-hint">{hint}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
